import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@components-clean/legacy/core/button/button';
import { CustomDialog, DialogActions, DialogContent, DialogTitle } from '@components-clean/legacy/core/legacy-dialog';
import { useTranslation } from '@hooks/index';
import Constants from '@utils/constants';

interface WarningLostDataDialogProps {
    open: boolean | undefined;
    onClose: (action: string) => void;
    customMessage?: string;
}

const WarningLostDataDialog = ({ open, onClose, customMessage }: WarningLostDataDialogProps) => {
    const { t } = useTranslation();

    const close = (message: string) => () => {
        onClose(message);
    };

    const warningContent = () => (
        <>
            {customMessage ? (
                <span className="confirm-text">{customMessage}</span>
            ) : (
                <>
                    <span className="confirm-text">{t('unsavedChanges')}</span>
                    <span className="confirm-text">{t('unsavedChangesLost')}</span>
                </>
            )}
        </>
    );

    return (
        <CustomDialog
            onClose={close(Constants.CANCEL)}
            fullWidth
            maxWidth="md"
            scroll="paper"
            open={open ?? false}
            className="custom-width-popup delete-cv-dialog"
        >
            <DialogTitle className="delete-cv-title">
                {t('unsavedData')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={close(Constants.CANCEL)}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="dialog-content">{warningContent()}</DialogContent>
            <DialogActions className="delete-cv-actions">
                <Button className="delete-cv-btn" id="close-popup" text="continue" onClick={close(Constants.CLOSE)} />
            </DialogActions>
        </CustomDialog>
    );
};

export default WarningLostDataDialog;
